import Vue from 'vue'
import Router from 'vue-router'
import home from '../view/home'
import login from '../view/login'
import monitor from '../components/monitoring/index'
import handleAlarm from '../components/handlealarm/index'
// import serviceOrder from '../components/serviceorder/index'
import supplierOrder from '../components/serviceorder/supplierOrder.vue'
import customerService from '../components/customerservice/index'
import activeService from '../components/datamanagement/activeService'
import serviceSupplierOrder from '../components/datamanagement/serviceSupplierOrder'
import organization from '../components/datamanagement/organization'
import serviceObject from '../components/datamanagement/serviceObject'
import device from '../components/datamanagement/device'
import user from '../components/datamanagement/user'
import account from '../components/datamanagement/account'
import SIPphone from '../components/datamanagement/SIPphone'
import project from '../components/datamanagement/project'
// import frequency from '../components/datamanagement/frequency'
import community from '../components/datamanagement/community'
import serviceProvider from '../components/serviceprovider/index'
import serviceType from '../components/servicemanagement/serviceType'
import supplierContent from '../components/servicemanagement/supplierContent.vue'
import supplierTypeService from '../components/servicemanagement/supplierTypeService.vue'
import serviceContent from '../components/servicemanagement/serviceContent'
import serviceUser from '../components/servicemanagement/serviceUser'
import alarmService from '../components/statisticalform/alarmService'
import serviceEvent from '../components/statisticalform/serviceEvent'
import seatsOnline from '../components/statisticalform/seatsOnline'
import callPhone from '../components/statisticalform/callPhone'
import companyOrder from '../components/statisticalform/companyOrder'
import systemWork from '../components/systemlog/systemWork'
import systemOperation from '../components/systemlog/systemOperation'
import systemError from '../components/systemlog/systemError'
import loginLog from '../components/systemlog/loginLog'
import exportLog from '../components/systemlog/exportLog'
import stateRefillCard from '../components/systemlog/stateRefillCard'
import deviceTest from '../components/systemlog/deviceTest'
import videoZg from '../components/systemlog/videoZg'
import voiceNotification from '../components/datamanagement/voiceNotification'
import homeManagement from '../components/datamanagement/homeManagement'
import callInfo from '../components/statisticalform/callInfo'
import otherStatistics from '../components/statisticalform/otherStatistics'
import deviceFactoryReset from '../components/systemlog/deviceFactoryReset'
import healthPage from '../components/datamanagement/healthPage'
import deviceSet from '../components/datamanagement/deviceSet'
import deviceGroupChat from '../components/datamanagement/deviceGroupChat'
import outworkStatistics from '../components/statisticalform/outworkStatistics'
import checkData from '../components/datamanagement/checkData'
import evaluateAbility from '../components/evaluateAbility/evaluateAbility'
import supplierType from '../components/serviceprovider/supplierType'
import examineOrder from '../components/servicemanagement/examineOrder.vue'
import servicePackage from '../components/servicemanagement/servicePackage.vue'
import serviceProjectBundle from '../components/servicemanagement/serviceProjectBundle.vue'
// 养老院
import institutionStaff from '../components/oldPersonHome/institutionStaff'
import roomManagement from '../components/oldPersonHome/roomManagement'
import oldPersonManagement from '../components/oldPersonHome/oldPersonManagement'
import dishesManagement from '../components/oldPersonHome/dishesManagement'
import menuManagement from '../components/oldPersonHome/menuManagement'
import orderSet from '../components/oldPersonHome/orderSet'
import rawMaterial from '../components/oldPersonHome/rawMaterial'
import awaitList from '../components/oldPersonHome/awaitList'
import checkIn from '../components/oldPersonHome/checkIn'
import leaveHospital from '../components/oldPersonHome/leaveHospital'
import oldCardManagement from '../components/oldPersonHome/oldCardManagement'
import nurseManagement from '../components/oldPersonHome/nurseManagement'
import controlsRecords from '../components/oldPersonHome/controlsRecords'
import setMeal from '../components/oldPersonHome/setMeal'
import accommodationStatistics from '../components/oldPersonHome/accommodationStatistics'
import roomStatistics from '../components/oldPersonHome/roomStatistics'
import bedStatistics from '../components/oldPersonHome/bedStatistics'
import changeRecords from '../components/oldPersonHome/changeRecords'
import chargeItem from '../components/oldPersonHome/chargeItem'
import chargePrice from '../components/oldPersonHome/chargePrice'
import oldPersonStatistics from '../components/oldPersonHome/oldPersonStatistics'
import healthDetection from '../components/oldPersonHome/healthDetection'
import changeService from '../components/oldPersonHome/changeService'
import outVisit from '../components/oldPersonHome/outVisit'
import goodsEscrow from '../components/oldPersonHome/goodsEscrow'
import healthManage from '../components/oldPersonHome/healthManage'
import buildingLayer from '../components/oldPersonHome/buildingLayer'
import eventMonitor from '../components/oldPersonHome/eventMonitor'
import siteMonitor from '../components/oldPersonHome/siteMonitor'
import organizationInfo from '../components/oldPersonHome/organizationInfo'
import deviceOrg from '../components/oldPersonHome/deviceOrg'
import visitManagement from '../components/oldPersonHome/visitManagement'
import deadlineWarn from '../components/oldPersonHome/deadlineWarn'
import serviceProject from '../components/oldPersonHome/serviceProject'
import serviceWorkOrder from '../components/oldPersonHome/serviceWorkOrder'
import rechargePay from '../components/oldPersonHome/rechargePay'
import financeStatistics from '../components/oldPersonHome/financeStatistics'
import oldPersonCheck from '../components/oldPersonHome/oldPersonCheck'
import weekSupply from '../components/oldPersonHome/weekSupply'
import foodEvidence from '../components/oldPersonHome/foodEvidence'
import foodSafetyRecord from '../components/oldPersonHome/foodSafetyRecord'
import healthData from '../components/oldPersonHome/healthData'
import historyRecords from '../components/oldPersonHome/historyRecords'
import checkOutApprove from '../components/oldPersonHome/checkOutApprove'
import restaurantManagement from '../components/oldPersonHome/restaurantManagement'
import serviceRecord from '../components/oldPersonHome/serviceRecord'
import dealAlarm from '../components/oldPersonHome/dealAlarm'
import ingredientVendor from '../components/oldPersonHome/ingredientVendor'
import dataScreen from '../components/monitoring/dataScreen'
import deviceStaff from '../components/oldPersonHome/deviceStaff'
import orderRecord from '../components/oldPersonHome/orderRecord'
import medicationRegistration from '../components/oldPersonHome/medicationRegistration'
import todayReminder from '../components/oldPersonHome/todayReminder'
import videoMonitor from '../components/oldPersonHome/videoMonitor'
import safetyActivity from '../components/oldPersonHome/safetyActivity'
import goodsMaterials from '../components/oldPersonHome/goodsMaterials'
import activityManagement from '../components/oldPersonHome/activityManagement'
import subsidyManagement from '../components/oldPersonHome/subsidyManagement.vue'
import registInOut from '../components/oldPersonHome/registInOut'
// import dayWork from '../components/oldPersonHome/dayWork'
import workShift from '../components/oldPersonHome/workShift.vue'
import weekMenu from '../components/oldPersonHome/weekMenu'
import fixedAssets from '../components/oldPersonHome/fixedAssets'
import doorRecord from '../components/oldPersonHome/doorRecord'
import padDevice from '../components/oldPersonHome/padDevice'
import faceDevice from '../components/oldPersonHome/faceDevice.vue'
import cashierDesk from '../components/oldPersonHome/cashierDesk.vue'
import chargeReminder from '../components/datamanagement/chargeReminder.vue'
import deviceSupplier from '../components/datamanagement/deviceSupplier.vue'
import userManagement from '../components/businessWeChat/userManagement.vue'
import projectSet from '../components/businessWeChat/projectSet'
import pointsSet from '../components/businessWeChat/pointsSet'
import pointsDetails from '../components/businessWeChat/pointsDetails.vue'
import feedback from '../components/oldPersonHome/feedback.vue'
import oldFeedBack from '../components/oldPersonHome/oldFeedBack.vue'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'login',
      component: login
    },
    {
      path: '/home',
      name: 'home',
      component: home,
      // redirect: '/monitor',
      children: [
        // 运营看板
        {path: '/monitor', name: '运营看板', component: monitor},
        // 数据大屏
        {path: '/dataScreen', name: '数据大屏', component: dataScreen},

        // 处理中心
        {path: '/handleAlarm', name: '事件处理', component: handleAlarm},
        {path: '/customerService', name: '客服关爱', component: customerService},
        {path: '/activeService', name: '发起服务', component: activeService},
        {path: '/serviceSupplierOrder', name: '当前订单', component: serviceSupplierOrder},
        {path: '/examineOrder', name: '订单审核', component: examineOrder},
        {path: '/servicePackage', name: '服务包', component: servicePackage},
        {path: '/serviceProjectBundle', name: '服务项目包', component: serviceProjectBundle},
        /* 服务商 */
        {path: '/serviceOrder', name: '服务商接单', component: supplierOrder},
        // {path: '/supplierOrder', name: '服务商接单', component: supplierOrder},

        // 系统管理
        /* 组织管理 */
        {path: '/organization', name: '组织管理', component: organization},
        {path: '/user', name: '员工管理', component: user},
        {path: '/account', name: '账号管理', component: account},
        {path: '/SIPphone', name: '呼叫中心管理', component: SIPphone},
        {path: '/stateRefillCard', name: 'SIM卡充值状态', component: stateRefillCard},
        /* 服务商管理 */
        {path: '/serviceProvider', name: '服务商', component: serviceProvider},
        {path: '/supplierType', name: '服务商管理', component: supplierType},
        {path: '/serviceType', name: '服务内容类型及内容', component: serviceType},
        {path: '/supplierTypeService', name: '服务类型', component: supplierTypeService},
        {path: '/supplierContent', name: '服务内容', component: supplierContent},
        {path: '/serviceContent', name: '服务商服务内容', component: serviceContent},
        {path: '/serviceUser', name: '服务商人员管理', component: serviceUser},
        /* 服务参数 */
        // {path: '/frequency', name: '服务频率设置', component: frequency},
        {path: '/project', name: '项目管理', component: project},
        /* 养老院开始 */
        {path: '/institutionStaff', name: '机构人员', component: institutionStaff},
        {path: '/roomManagement', name: '房间管理', component: roomManagement},
        {path: '/oldPersonManagement', name: '老人档案', component: oldPersonManagement},
        {path: '/dishesManagement', name: '菜品管理', component: dishesManagement},
        {path: '/menuManagement', name: '菜谱管理', component: menuManagement},
        {path: '/setMeal', name: '套餐管理', component: setMeal},
        {path: '/orderSet', name: '老人订餐', component: orderSet},
        {path: '/rawMaterial', name: '食材管理', component: rawMaterial},
        {path: '/awaitList', name: '轮候登记', component: awaitList},
        {path: '/checkIn', name: '入住/退住', component: checkIn},
        {path: '/leaveHospital', name: '出院', component: leaveHospital}, // 弃
        {path: '/oldCardManagement', name: '老年卡管理', component: oldCardManagement},
        {path: '/nurseManagement', name: '护理管理', component: nurseManagement},
        {path: '/controlsRecords', name: '人员操作记录', component: controlsRecords},
        {path: '/accommodationStatistics', name: '入住报表', component: accommodationStatistics},
        {path: '/checkInStatistics', name: '入住情况', component: accommodationStatistics},
        {path: '/roomStatistics', name: '房间统计', component: roomStatistics},
        {path: '/bedStatistics', name: '床位统计', component: bedStatistics},
        {path: '/changeRecords', name: '变更记录', component: changeRecords},
        {path: '/chargeItem', name: '收费项目', component: chargeItem},
        {path: '/chargePrice', name: '收费价格设置', component: chargePrice},
        {path: '/oldPersonStatistics', name: '人员入住统计', component: oldPersonStatistics},
        {path: '/healthDetection', name: '健康监控', component: healthDetection},
        {path: '/changeService', name: '服务计划与变更', component: changeService},
        {path: '/outVisit', name: '外出探访', component: outVisit}, // 弃
        {path: '/goodsEscrow', name: '物品代管', component: goodsEscrow},
        {path: '/healthManage', name: '健康管理', component: healthManage},
        {path: '/buildingLayer', name: '楼栋楼层', component: buildingLayer},
        {path: '/eventMonitor', name: '事件监控', component: eventMonitor},
        {path: '/siteMonitor', name: '位置监控', component: siteMonitor},
        {path: '/organizationInfo', name: '机构信息', component: organizationInfo},
        {path: '/deviceOrg', name: '监护设备', component: deviceOrg},
        {path: '/deviceSupplier', name: '服务商人员设备', component: deviceSupplier},
        {path: '/visitManagement', name: '探视管理', component: visitManagement},
        {path: '/deadlineWarn', name: '到期提醒', component: deadlineWarn},
        {path: '/serviceProject', name: '类别设置', component: serviceProject},
        {path: '/serviceWorkOrder', name: '服务工单', component: serviceWorkOrder},
        {path: '/rechargePay', name: '充值消费', component: rechargePay},
        {path: '/financeStatistics', name: '财务统计', component: financeStatistics},
        {path: '/oldPersonCheck', name: '老人账单', component: oldPersonCheck},
        {path: '/weekSupply', name: '每周供应', component: weekSupply},
        {path: '/foodEvidence', name: '食物留样', component: foodEvidence},
        {path: '/foodSafetyRecord', name: '安全记录', component: foodSafetyRecord},
        {path: '/healthData', name: '健康数据', component: healthData},
        {path: '/historyRecords', name: '历史记录', component: historyRecords},
        {path: '/checkOutApprove', name: '退住审批', component: checkOutApprove},
        {path: '/restaurantManagement', name: '餐厅管理', component: restaurantManagement},
        {path: '/serviceRecord', name: '护理记录', component: serviceRecord},
        {path: '/dealAlarm', name: '事件处理', component: dealAlarm},
        {path: '/ingredientVendor', name: '食材供应商', component: ingredientVendor},
        {path: '/deviceStaff', name: '员工设备', component: deviceStaff},
        {path: '/orderRecord', name: '工单记录', component: orderRecord},
        {path: '/medicationRegistration', name: '用药登记', component: medicationRegistration},
        {path: '/todayReminder', name: '当日提醒', component: todayReminder},
        {path: '/videoMonitor', name: '视频监控', component: videoMonitor},
        {path: '/safetyActivity', name: '消防活动管理', component: safetyActivity},
        {path: '/goodsMaterials', name: '物资管理', component: goodsMaterials},
        {path: '/activityManagement', name: '活动记录', component: activityManagement},
        {path: '/subsidyManagement', name: '补贴管理', component: subsidyManagement},
        {path: '/registInOut', name: '出入登记', component: registInOut},
        // {path: '/dayWork', name: '电子排班', component: dayWork},
        {path: '/dayWork', name: '电子排班', component: workShift},
        {path: '/weekMenu', name: '每周菜单', component: weekMenu},
        {path: '/fixedAssets', name: '固定资产', component: fixedAssets},
        {path: '/doorRecord', name: '门禁记录', component: doorRecord},
        {path: '/padDevice', name: '信息终端', component: padDevice},
        {path: '/faceDevice', name: '人脸设备', component: faceDevice},
        {path: '/cashierDesk', name: '餐饮收银', component: cashierDesk},
        {path: '/feedback', name: '员工反馈', component: feedback},
        {path: '/oldFeedBack', name: '家属/老人反馈', component: oldFeedBack},
        /* 养老院结束 */

        // 数据管理
        {path: '/community', name: '小区/机构管理', component: community},
        {path: '/homeManagement', name: '家庭/机构管理', component: homeManagement},
        {path: '/serviceObject', name: '服务对象管理', component: serviceObject},
        {path: '/device', name: '监护设备', component: device},
        {path: '/healthPage', name: '健康监控', component: healthPage},
        {path: '/voiceNotification', name: '语音通知', component: voiceNotification},
        {path: '/deviceSet', name: '设备设置', component: deviceSet},
        {path: '/deviceGroupChat', name: '设备群聊', component: deviceGroupChat},
        {path: '/checkData', name: '数据审核', component: checkData},

        // 报表统计
        {path: '/alarmService', name: '事件统计', component: alarmService},
        {path: '/serviceEvent', name: '服务日志', component: serviceEvent},
        {path: '/seatsOnline', name: '坐席在线统计', component: seatsOnline},
        {path: '/callPhone', name: '客服关爱统计', component: callPhone},
        {path: '/callInfo', name: '呼叫信息统计', component: callInfo},
        {path: '/otherStatistics', name: '计生法律统计', component: otherStatistics},
        {path: '/outworkStatistics', name: '外勤客服统计', component: outworkStatistics},
        {path: '/companyOrder', name: '服务商服务记录', component: companyOrder},

        // 系统日志
        {path: '/systemWork', name: '系统运行状态', component: systemWork},
        {path: '/loginLog', name: '系统登录日志', component: loginLog},
        {path: '/exportLog', name: '系统导出日志', component: exportLog},
        {path: '/systemOperation', name: '系统运维设置', component: systemOperation},
        {path: '/systemError', name: '系统错误日志', component: systemError},
        {path: '/deviceFactoryReset', name: '设备出厂设置', component: deviceFactoryReset},
        {path: '/deviceTest', name: '设备测试', component: deviceTest},
        {path: '/videoZg', name: '视频探访', component: videoZg},
        {path: '/chargeReminder', name: '费用管理', component: chargeReminder},
        {path: '/userManagement', name: '注册用户', component: userManagement},
        {path: '/projectSet', name: '项目设置', component: projectSet},
        {path: '/pointsSet', name: '积分设置', component: pointsSet},
        {path: '/pointsDetails', name: '积分详情', component: pointsDetails}
      ]
    },
    {
      path: '/evaluateAbility',
      name: '能力评估',
      component: evaluateAbility
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js